var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swipe-box"},[_c('van-swipe',{staticClass:"my-swipe",attrs:{"autoplay":3000,"indicator-color":"#ED301D"}},_vm._l((_vm.banner),function(item,index){return _c('van-swipe-item',{key:index,on:{"click":function($event){return _vm.goToDetails(item)}}},[_c('img',{attrs:{"src":item.image}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }